import _isArray from 'lodash/isArray';

export default function findDomain(domains = []) {
  if (!_isArray(domains)) return '';

  const filteredDomains = domains.filter(domain => !domain.includes('aspen'));

  let domain = filteredDomains[0] || domains[0] || '';

  if (!domain) return '';

  return domain.startsWith('https:') ? domain : `https://${domain}`;
}
